<template>
    <path :style="{ fill: color }" d="M73.9,50.6C73.9,50.6,73.9,50.6,73.9,50.6c0-3.6,0.1-5.7-0.5-5.7c-0.6,0-1.1,2-1.1,2l0,0
	c-0.5,2.8-1.1,5.5-2,7c-2.5,4-5.4,4.2-8.5,3.8c-3.2-0.4-4.2-1.6-7.9-1.6s-6.3,2-9.7,1.4c-3.4-0.5-5.5-0.4-6.9-3.9
	c-0.3-0.7-0.6-2.1-1-3.6c0,0,0,0,0,0c-0.6-2.2-1.5-6.2-2.1-6.1s-0.6,1.7-0.6,1.7l0,0c0,1.4,0.1,3.2,0.1,5c0.1,3.8,0.1,7.8,0.7,9.3
	c1.6,4,9.6,12.9,14.2,14.6c4.6,1.7,9.3,1.2,12.2-0.5c2.9-1.7,11.9-10.5,12.7-14.8c0.4-2.4,0.2-5.3,0.3-8.3
	C73.9,50.8,73.9,50.7,73.9,50.6z M53.9,63.8c-3.3,0-5.9-1.8-5.6-2.8c0.3-1,3.2-1.3,5.4-1.3s5.4,0.2,5.5,1.1
	C59.4,61.8,57.2,63.8,53.9,63.8z"/>
</template>

<script>
    import Mouth from './Mouth';

    export default {
        name: 'Mouth1',
        mixins: [Mouth],
    }
</script>
